/**
 * Author: BaiJiFeiLong@gmail.com
 * Datetime: 2017/5/18 上午11:51
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';
import {} from 'react-bootstrap';

export default class InstrumentTypeSelect extends Component {
    static propTypes = {
        value: PropTypes.string.isRequired,
        onSelect: PropTypes.func.isRequired
    };

    render() {
        const { onSelect, ...props } = this.props;
        return (
            <FormControl
                bsSize="sm"
                componentClass="select"
                {...props}
                onChange={(e) => onSelect(e.target.value)}
            >
                <option value="guitar">木吉他</option>
                <option value="eguitar">电吉他</option>
                <option value="ukulele">尤克里里</option>
                <option value="kalimba"> 卡林巴 </option>
                <option value="djembe"> 非洲鼓</option>
                <option value="piano">钢琴</option>
                <option value="music_basis">音基</option>
                <option value="harmonica">口琴</option>
                <option value="other">其他</option>
                <option value="guzheng">古筝</option>
                <option value="ocarina">陶笛</option>
                <option value="vocal">声乐</option>
                <option value="saxophone">萨克斯</option>
                <option value="zhudi">竹笛</option>
                <option value="bass">贝斯</option>
            </FormControl>
        );
    }
}



// WEBPACK FOOTER //
// src/components/InstrumentTypeSelect.js